import { Slide, TableCell } from '@features/powerpoint';
import { contentSlideHeader, generateTable } from '../../../../utils';
import { TABLE_HEADER_OPTIONS } from '../sales-attribution/rsa-dimensions-table-slide';
import { CampaignAnalyticsSlideProps } from './build-campaign-analytics-slides';
import { brandLocationsRows } from './data-transforms';

const SMALL_COLUMN_WIDTH = 1;
const MEDIUM_COLUMN_WIDTH = 2;
const LARGE_COLUMN_WIDTH = 5;
const VISITS_DISCLAIMER =
  'Visit Index (Average = 100) : Baseline: Observable InMarket universe';
const visitColumnLabels: TableCell[] = [
  {
    text: 'Rank',
    options: TABLE_HEADER_OPTIONS,
  },
  {
    text: 'Name',
    options: TABLE_HEADER_OPTIONS,
  },
  {
    text: 'Address',
    options: { ...TABLE_HEADER_OPTIONS, align: 'left' },
  },
  {
    text: 'City',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'State',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'Zip',
    options: { ...TABLE_HEADER_OPTIONS },
  },
  {
    text: 'Index',
    options: { ...TABLE_HEADER_OPTIONS },
  },
];

export const brandLocationsTableSlide = (
  props: CampaignAnalyticsSlideProps
): Slide => {
  const tables = [];

  tables.push(
    generateTable(
      visitColumnLabels,
      brandLocationsRows(props.campaignAnalyticsReport.brandLocationVisits),
      {
        rowH: 0.1,
        colW: [
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          LARGE_COLUMN_WIDTH,
          MEDIUM_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
          SMALL_COLUMN_WIDTH,
        ],
      }
    )
  );

  return {
    slideMaster: props.slideMaster,
    tables,
    texts: [
      contentSlideHeader('Top 20 Brand Locations Visited', {
        x: 0.75,
        y: 0.6,
      }),
      { text: VISITS_DISCLAIMER, options: { x: 0.67, y: 6.81, fontSize: 8 } },
    ],
  };
};
